import styled from 'styled-components';

export const Line = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
`;

export const Head = styled.div`
  margin: 0 10px 0 20px;
  color: #aab2b8;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
  text-align: right;
  line-height: 1;
`;
